import { MapPin, ShieldCheck, Headphones, BadgeCheck, FileText } from "lucide-react";

const items = [
  { label: "Currently Serving", value: "Trivandrum · Chennai · Coimbatore · Kochi · Bengaluru", icon: MapPin },
  { label: "Reliability", value: "100% Guaranteed", icon: BadgeCheck },
  { label: "Customer Support", value: "24 / 7", icon: Headphones },
  { label: "Drivers", value: "Police Verified", icon: ShieldCheck },
  { label: "Billing", value: "GST Compliant", icon: FileText },
];

export default function Stats() {
  return (
    <section className="bg-white" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 -mt-12 relative z-10">
        <div className="bg-[#0D1B40] rounded-2xl shadow-[0_30px_70px_-25px_rgba(13,27,64,0.55)] overflow-hidden">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-white/5">
            {items.map((it) => (
              <StatCell key={it.label} {...it} />
            ))}
          </div>
        </div>
      </div>
      <div className="h-20" />
    </section>
  );
}

function StatCell({ icon: Icon, label, value }) {
  return (
    <div className="bg-[#0D1B40] p-6 md:p-7 flex flex-col items-start gap-2.5">
      <div className="w-10 h-10 rounded-md bg-[#F5A623]/15 text-[#F5A623] flex items-center justify-center">
        <Icon size={18} />
      </div>
      <div className="text-[11px] tracking-[0.18em] text-white/60 font-semibold uppercase">
        {label}
      </div>
      <div className="text-white font-bold text-[15px] md:text-[16px] leading-snug">
        {value}
      </div>
    </div>
  );
}
